module.exports = __webpack_public_path__ + "img/download-pencil-outline.05da50c8.svg";